import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === 'production') {
  // Silence non-error console output in production
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.warn = () => {};

  // Suppress unhandled promise rejections originating from Cloudflare Turnstile's
  // internal PAT verification flow (harmless — widget still functions correctly)
  window.addEventListener('unhandledrejection', (event) => {
    const stack = event.reason?.stack ?? '';
    if (stack.includes('challenges.cloudflare.com')) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
